import axios from "axios";
import React, { useEffect } from "react";
import CertificateLearningModal from "../CertificateLearningModal/CertificateLearningModal";

const LearningDownloadCertificate = ({ learningSession }) => {
  const [modalShowCertificate, setModalShowCertificate] = React.useState(false);
  const [showDiv, setShowDiv] = React.useState(false);

  return (
    <>
      {showDiv ? (
        <div className="row mx-3 bg-dark">
          <div className="mb-3 mt-3 row justify-content-between p-2 ">
            <div className="col-md-7 text-center BlackUou text-light pt-3 fw-bold ms-3">
              Download Your Certificate
            </div>

            <div className="col-md-4  text-center fw-bold rounded-3 text-light py-1">
              <button
                onClick={() => setModalShowCertificate(true)}
                className="btnAppD py-2 px-5 fw-bold"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mx-3 bg-dark">
          <div className="mb-3 mt-3 row justify-content-center p-2 ">
            <div className="col-md-6  text-center fw-bold rounded-3 text-light py-1">
              <button
                onClick={() => setShowDiv(true)}
                className="btnAppD py-2 px-5 fw-bold"
              >
                Collect Certificate
              </button>
            </div>
          </div>
        </div>
      )}

      <CertificateLearningModal
        show={modalShowCertificate}
        learningSession={learningSession}
        onHide={() => setModalShowCertificate(false)}
      />
    </>
  );
};

export default LearningDownloadCertificate;
